





import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
@Component({
  components: {
  },
})
export default class LiveDetail extends AbpBase {
  url: any = ''
  mounted() {
    this.url = this.$route.query.url
  }
}
